import React, { useState } from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from '@mui/material';

import { FlexCol, FlexRow } from '../../../../common/components/v2';
import { getFormattedTimestamp } from '../../../../common/helpers';
import useAnalytics from '../../../../useAnalytics';
import { Document } from '../../../tasks/types/document';
import styles from '../../styles.module.scss';

export const FileDetailsItem = ({
  showLeftLabel = true,
  leftItem = '',
  canDelete = false,
  document,
  fileOpenHandler,
  fileDeletehandler,
}: {
  showLeftLabel?: boolean;
  leftItem?: string;
  canDelete?: boolean;
  document: Document;
  fileOpenHandler: (uri: string, fileName: string) => void;
  fileDeletehandler?: (documentId: number, reason: string) => void;
}) => {
  const { logEvent } = useAnalytics();
  const onClick = async (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    e.preventDefault();
    logEvent('Attachment clicked', {
      ...document,
      showLeftLabel,
      leftItem,
      canDelete,
      flush: true,
    });
    fileOpenHandler(document.uri, document.fileName);
  };
  const onDeleteDocument = async (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    setReasonOpen(false);
    e.preventDefault();
    if (fileDeletehandler && reason.length > 0) {
      logEvent('Attachment delete', {
        ...document,
        showLeftLabel,
        leftItem,
        canDelete,
        flush: true,
      });
      fileDeletehandler(document.documentId, reason);
    }
  };

  const [reason, setReason] = useState('');
  const [reasonOpen, setReasonOpen] = useState(false);
  const closeReasonDialog = () => {
    setReason('');
    setReasonOpen(false);
  };

  const openReasonDialog = () => {
    setReasonOpen(true);
  };
  return (
    <>
      <FlexRow className={styles.MarginTop}>
        {showLeftLabel ? (
          <FlexCol sm={2} className={styles.TaskLeftCell}>
            {leftItem}
          </FlexCol>
        ) : (
          <></>
        )}
        <FlexCol sm={1} className={styles.TaskInfoCell}>
          {fileDeletehandler && canDelete && !document.deleted && (
            <button
              className={styles.DeleteDocument}
              onClick={openReasonDialog}
            >
              X
            </button>
          )}
        </FlexCol>
        <FlexCol sm={6} className={styles.TaskInfoCell}>
          {document.deleted ? (
            <button className={styles.DocumentDeleted}>
              {document.fileName}
            </button>
          ) : (
            <button className={styles.Document} onClick={onClick}>
              {document.fileName}
            </button>
          )}

          <span className={styles.Date}>
            {getFormattedTimestamp(document.createdAt)}
          </span>
        </FlexCol>
      </FlexRow>
      <Dialog open={reasonOpen} onClose={closeReasonDialog}>
        <DialogTitle>Delete Uploaded Document</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please input reason to delete this file.
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            label="Reason"
            type="text"
            fullWidth
            variant="standard"
            value={reason}
            onChange={e => {
              setReason(e.target.value);
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={closeReasonDialog}>Cancel</Button>
          <Button disabled={reason.length === 0} onClick={onDeleteDocument}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
